<div [innerHTML]="html | safeHtml" class="preview"></div>